import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  templateUrl: './configs.component.html',
  styleUrls: ['./configs.component.scss']
})
export class ConfigsComponent implements OnInit, OnDestroy {
  customerid: any;
  //  @Input() projectid: string = "3bT1leJ7VRxz0PiHPajL";
  configs: any;
  projectid: string;
  project: any;
  userid: string;

  // Subscriptions to be cleaned up
  private subscriptions: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private rtdb: AngularFireDatabase,
    public afs: AngularFirestore,
    private authService: AuthService,
    @Inject(Router) public router: Router,
    @Inject(ActivatedRoute) public route: ActivatedRoute
  ) { }

  async ngOnInit(): Promise<void> {
    this.projectid = this.route.snapshot.paramMap.get('projectid');

    const user = await this.authService.authState.pipe(first()).toPromise();
    this.userid = user?.uid;
    if (!this.userid) {
      console.error("ConfigsComponent: User not logged in or UID unavailable.");
      return;
    }

    console.log("loading config for", this.userid, this.projectid);

    await this.loadData();
  }

  ngOnDestroy(): void {
    // Clean up all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  async loadData(): Promise<void> {
    try {
      // Load project data
      const projectPath = "projectspublic" + "/" + this.projectid;
      this.project = await this.afs.doc(projectPath)
        .valueChanges({ idField: "id" })
        .pipe(first())
        .toPromise();

      // Load configs
      const configsPath = "/configs/" + this.userid + "/" + this.projectid;
      this.configs = await this.afs.collection(configsPath)
        .valueChanges({ idField: "id" })
        .pipe(first())
        .toPromise();

      // Sort configs by savetime in descending order (newest first)
      if (this.configs) {
        this.configs.sort((a, b) => {
          const timeA = a.enduserdata?.savetime ? new Date(a.enduserdata.savetime).getTime() : 0;
          const timeB = b.enduserdata?.savetime ? new Date(b.enduserdata.savetime).getTime() : 0;
          return timeB - timeA; // Descending order
        });
      }

      console.log('configs', this.configs);
    } catch (error) {
      console.error('Error loading data:', error);
    }
  }

  sendmail(configuration: any) {
    this.afs.collection("mail")
      .add({
        to: configuration.enduserdata.mail,
        message: {
          subject: "Hello from Firebase!",
          text: "This is the plaintext section of the email body.",
          html: "This is the <code>HTML</code> section of the email body.",
        },
      })
      .then(() => console.log("Queued email for delivery!"));
  }

  deleteconfig(c) {
    if (!this.userid) return;
    this.afs.doc("/configs/" + this.userid + "/" + this.projectid + "/" + c.id).delete();
  }

  async addconfig() {
    if (!this.userid) return;
    await this.afs.collection("/configs/" + this.userid + "/" + this.projectid).add({ date: new Date(), name: 'new config' });
  }

  cloneconfig(c) {
    if (!this.userid) return;
    var cloned = { ...c };
    delete cloned.id;
    cloned.name = cloned.name + " (copy)";
    this.afs.collection("/configs/" + this.userid + "/" + this.projectid).add(cloned);
  }

  async copyconfiglink(c) {
    if (!this.userid) return;
    // ... (clipboard logic) ...
  }
}
